
{
  "familyId": "SPR-SAM-TUSSEN-N",
  "questions": [
    {
      "id": "SPR-SAM-TUSSEN-N-001",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["pannenkoek", "pannekoek", "pannekoeken", "pankoek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Tussen-n regel", "content": "Als het eerste deel een meervoud op -en heeft, schrijf je een tussen-n: pannen (meervoud van pan) + koek = pannenkoek. Denk aan: meerdere pannen → pannenkoek.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "linking_n_compound",
      "variantIndex": 1,
      "feedback": { "explanationText": "Het eerste deel is 'pannen' (meervoud van pan). Bij een meervoud op -en schrijf je een tussen-n: pannen + koek = pannenkoek.", "distractorExplanations": { "0": "Correct! Het meervoud 'pannen' krijgt een tussen-n: pannenkoek.", "1": "Fout: je vergeet de tussen-n. Het meervoud is 'pannen', dus pannenkoek.", "2": "Fout: 'pannekoeken' is dubbel meervoud. Het is pannenkoek (enkelvoud).", "3": "Fout: je hebt de tussen-n nodig. Het meervoud 'pannen' + koek = pannenkoek." } }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-002",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["dorpsplein", "dorpplein", "dorpeplein", "dorppen plein"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Tussen-s regel", "content": "Bij sommige samenstellingen schrijf je een tussen-s: dorp + plein = dorpsplein. Dit komt vaak voor bij woorden die eindigen op een medeklinker.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "linking_s_compound",
      "variantIndex": 1,
      "feedback": { "explanationText": "Bij 'dorp + plein' schrijf je een tussen-s: dorpsplein. Dit maakt het woord makkelijker uit te spreken.", "distractorExplanations": { "0": "Correct! Je schrijft een tussen-s: dorpsplein.", "1": "Fout: je hebt een tussen-s nodig voor de uitspraak: dorpsplein.", "2": "Fout: je schrijft geen tussen-e, maar een tussen-s: dorpsplein.", "3": "Fout: samengestelde woorden schrijf je aan elkaar: dorpsplein." } }
    }
  ]
}
